import { Fragment, useState } from "react";
import banner from "../assets/images/bannerDownloadMinecraft.jpg";
import { TitleButton } from "./UI/Title";
import { Button, Container, Grid2 } from "@mui/material";

import download1 from "../assets/images/download1.png";
import download2 from "../assets/images/download2.png";
import download3 from "../assets/images/download3.png";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const screens = [download1, download2, download3];
const Download = () => {
  const [selectedScreen, setSelectedScreen] = useState("");
  const screenSelectHandler = (index) => {
    setSelectedScreen(index);
  };
  return (
    <Fragment>
      <img src={banner} alt="Generation AI" className="bannerImage" />
      <Container fixed>
        <div className="mainBody">
          <h1>Getting Started with Minecraft Education</h1>
        </div>

        <section>
          <TitleButton
            title={"Select Version"}
            paragraph={
              "Check what version of access to Minecraft Education you have. "
            }
          />
          <h4 style={{ marginBottom: "0.7rem" }}>STEP 3</h4>
          <p>
            Once you sign in to Minecraft Education, see which one of the three
            screens below appears! Select the screen that appears
          </p>
          <Grid2 container justifyContent={"center"}>
            <Grid2 size={{ xs: 12 }}>
              <ul className="downloadImages">
                {screens.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => screenSelectHandler(index)}
                    className={index === selectedScreen ? "active" : ""}
                  >
                    <span className="screen">Screen {index + 1}</span>
                    <img src={item} alt="download 1" />
                  </li>
                ))}
              </ul>
              <Link
                to={
                  selectedScreen === 0
                    ? "/full-version"
                    : selectedScreen === 1
                    ? "/trial-version"
                    : "/download-again"
                }
                className="btnDownloaded"
                onClick={(event) => {
                  if (selectedScreen === "") event.preventDefault();
                }}
              >
                <Button
                  variant="outlined"
                  disabled={selectedScreen === "" ? true : false}
                >
                  Next <ArrowForwardIcon />
                </Button>
              </Link>
            </Grid2>
          </Grid2>
        </section>
      </Container>
    </Fragment>
  );
};

export default Download;
